/**
 * @description 判断浏览器的隐身(无痕)模式
 */
export function browserIsHide () {
  let fs = window.RequestFileSystem || window.webkitRequestFileSystem;
  let browserFlag = true // true-非无痕模式；false-无痕模式
  if (!fs) {
    console.log("check failed?");
  } else {
    fs(window.TEMPORARY,100,function(){
      console.log('非无痕模式')
    },function(){
      browserFlag = false
      //alert('您已开启无痕模式，为了不影响正常功能使用，请立即关闭！');
    });
  }
  return browserFlag
}


// WEBPACK FOOTER //
// ./src/utils/bowderIsHiden.js